import { OptionalExtraPresenter } from 'shared/presenters'
import { defined, definedNotNull } from 'shared/presenters/presenter'
import { OptionalExtraQuantity } from 'shared/enums/schedulables'
import { Chosen_Optional_Extra_Input } from 'shared/presenters/graphqlTypes'
/**
 * Formats chosen optional extras into an array containing
 * id, name, individual price, quantity and total price
 * of each chosen optional extra.
 *
 * Used when displaying detailed information about chosen optional extras.
 * */
const formatOptionalExtras = (
  optionalExtras?: OptionalExtraPresenter[],
  optionalExtraFormikValue?: OptionalExtraQuantity['optionalExtra']
): OptionalExtra[] | undefined => {
  if (
    !optionalExtras ||
    !optionalExtraFormikValue ||
    Object.keys(optionalExtraFormikValue).length <= 0
  ) {
    return
  }

  return optionalExtras.map(optionalExtra => {
    const price = definedNotNull(optionalExtra.price_pence)
    const id = defined(optionalExtra.id)

    return {
      id: defined(optionalExtra.id),
      name: optionalExtra.name(),
      price,
      quantity: optionalExtraFormikValue[id],
      total: optionalExtraFormikValue[id] * price
    }
  })
}

export default formatOptionalExtras

export interface OptionalExtra {
  id: string
  name: string
  price: number
  quantity: number
  total: number
}

export const calculateOptionalExtrasTotalPriceForRental = (
  optionalExtras?: OptionalExtra[]
) => {
  if (!optionalExtras) return 0

  return optionalExtras
    .map(optionalExtra => optionalExtra.total)
    .reduce((previous, current) => current + previous, 0)
}

/**
 * Formats chosen optional extras into an array of chosen_optional_extra_inputs.
 *
 * Used when passing chosen optional extras as a variable to the backend.
 * */
export const formatChosenOptionalExtrasIntoInputs = (
  optionalExtraFormikValue: OptionalExtraQuantity['optionalExtra']
) => {
  if (!optionalExtraFormikValue) return

  const optionalExtraVars: Chosen_Optional_Extra_Input[] = Object.entries(
    optionalExtraFormikValue
  ).map(([key, value]) => ({
    optional_extra_id: key,
    quantity: value
  }))

  if (optionalExtraVars?.length === 0 || !optionalExtraFormikValue) {
    return
  }

  return optionalExtraVars
}
